import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'bmd-home',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  styleUrls: ['./home.component.scss'],
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnDestroy, OnInit {
  updates: string[];
  subscriptions: Subscription[] = [];

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.updates = this.route.snapshot.data['updates'];
  }

  goTo(url: string): void {
    window.open(url, '_blank');
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscriber => subscriber.unsubscribe());
  }
}
